import { TableWidgetProps } from './TableWidget';
import { TableWidgetRenderData } from './renderTypes';
import { DashboardModes } from '../types';
import { newTableTheme } from '@ardoq/table-legacy';
import { GetComponentLinkHandler } from '@ardoq/report-reader';
import { ArdoqId, WidgetTypes } from '@ardoq/api-types';
import { Locale } from '@ardoq/locale';
import { returnFalse } from '@ardoq/common-helpers';
import { type I18nLocale } from '@ardoq/i18n';

type GetTableWidgetPropsParam = {
  widgetRenderData: TableWidgetRenderData;
  userLocale: Locale;
  i18nLocale: I18nLocale;
  dashboardMode: DashboardModes;
  getComponentLinkHandler?: GetComponentLinkHandler;
  hasComponentReadPermission: ((componentId: ArdoqId) => boolean) | undefined;
  selectedConfidentialFieldNames?: string[];
};

export const getTableWidgetProps = ({
  widgetRenderData,
  dashboardMode,
  userLocale,
  i18nLocale,
  getComponentLinkHandler,
  hasComponentReadPermission,
  selectedConfidentialFieldNames = [],
}: GetTableWidgetPropsParam): TableWidgetProps & {
  viewType: WidgetTypes.TABLE;
} => ({
  ...widgetRenderData,
  TableComponent:
    dashboardMode === DashboardModes.METRICS ? newTableTheme.Table : undefined,
  userLocale,
  i18nLocale,
  hasComponentReadPermission: hasComponentReadPermission ?? returnFalse,
  getComponentLinkHandler,
  selectedConfidentialFieldNames,
});
